import { create } from 'zustand';

import { ButtonDialog } from '@autopass-web/mochi-component';

import styles from './index.module.scss';

import amplitude from '#/guest-aps/services/amplitude';
import { sessionStorageController } from '#/guest-aps/services/storages';

type Value = {
  onSubmit: () => void;
  onCancel: () => void;
  plateNumber: string;
  parkingRecordId;
};

type NewUserDiscountDialogStore = {
  value: Value;
  onDisplay: (value: Value) => void;
  onClose: () => void;
};

export const useNewUserDiscountDialogStore = create<NewUserDiscountDialogStore>(
  (set) => ({
    value: undefined,
    onDisplay: (value: Value) => {
      set({
        value,
      });
    },
    onClose: () => {
      set({ value: undefined });
    },
  }),
);

export const NewUserDiscountDialog = () => {
  const parkinglotInfo = sessionStorageController.getParkinglot();
  const { value, onClose } = useNewUserDiscountDialogStore();

  const trackingData = {
    停車場id: parkinglotInfo?.partner_id,
    停車場名稱: parkinglotInfo?.name,
    車牌號碼: value?.plateNumber,
    parkingRecordId: value?.parkingRecordId,
  };

  return (
    <ButtonDialog
      onView={() => {
        amplitude.track('車牌選取頁_新用戶折扣dialog-pageview', trackingData);
      }}
      onDismiss={() => {
        amplitude.track('車牌選取頁_新用戶折扣dialog-close', trackingData);
        onClose();
      }}
      show={!!value}
      title="請選擇支付方式"
      message={
        <div className={styles.message}>
          本場支援車牌辨識扣款，加入車麻吉會員不用再手動繳費，直接開到柵欄前，等待辨識自動扣款出場。
          <br />
          <br />
          新戶再享專屬
          <br />
          「Autopass Lite 免費 30 日」
        </div>
      }
      buttonList={[
        {
          theme: 'positive',
          content: '車辨付款',
          onClick: () => {
            amplitude.track(
              '車牌選取頁_新用戶折扣dialog-車辨付款',
              trackingData,
            );
            value?.onSubmit();
          },
          beLoading: false,
        },
        {
          theme: 'cancel',
          content: '仍手動繳費',
          onClick: () => {
            amplitude.track(
              '車牌選取頁_新用戶折扣dialog-仍手動繳費',
              trackingData,
            );
            value?.onCancel();
          },
          beLoading: false,
        },
      ]}
    />
  );
};

type PaymentSettingDialogStore = {
  value: Value;
  onDisplay: (value: Value) => void;
  onClose: () => void;
};

export const usePaymentSettingDialogStore = create<PaymentSettingDialogStore>(
  (set) => ({
    value: undefined,
    onDisplay: (value: Value) => {
      set({
        value,
      });
    },
    onClose: () => {
      set({ value: undefined });
    },
  }),
);

export const PaymentSettingDialog = () => {
  const parkinglotInfo = sessionStorageController.getParkinglot();
  const { value, onClose } = usePaymentSettingDialogStore();

  const isShow = !!value;

  const trackingData = {
    停車場id: parkinglotInfo?.partner_id,
    停車場名稱: parkinglotInfo?.name,
    車牌號碼: value?.plateNumber,
    parkingRecordId: value?.parkingRecordId,
  };

  return (
    <ButtonDialog
      onView={() => {
        amplitude.track('車牌選取頁_付款設定dialog-pageview', trackingData);
      }}
      onDismiss={() => {
        amplitude.track('車牌選取頁_付款設定dialog-close', trackingData);
        onClose();
      }}
      show={isShow}
      title="還差最後一步"
      message={
        <div className={styles.message}>
          你具備 Autopass x 車麻吉
          <br />
          車辨出場自動扣資格，僅需完成最後信用卡設定，即可直接車辨出場
        </div>
      }
      buttonList={[
        {
          theme: 'positive',
          content: '車辨付款',
          onClick: () => {
            amplitude.track('車牌選取頁_付款設定dialog-車辨付款', trackingData);
            value?.onSubmit();
          },
          beLoading: false,
        },
        {
          theme: 'cancel',
          content: '仍手動繳費',
          onClick: () => {
            amplitude.track(
              '車牌選取頁_付款設定dialog-仍手動繳費',
              trackingData,
            );
            value?.onCancel();
          },
          beLoading: false,
        },
      ]}
    />
  );
};
